<template>
  <div id="hjwq">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "hjwq"
};
</script>

<style lang="less" scoped>
#hjwq {
  overflow: hidden;
  position: relative;
  width: 100%;
  // min-width: 320px;
  // max-width: 750px;
  height: 100%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/App.vue